import React from 'react';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function PartnersSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t,
    direction
  } = useLanguage();
  const ArrowIcon = direction === 'rtl' ? ArrowLeftIcon : ArrowRightIcon;
  return <section className="py-32 md:py-44 relative overflow-hidden" style={{
    background: 'linear-gradient(to bottom, #DEEFF2, #FFFFFF)'
  }} dir={direction} data-id="element-195">
      {/* Background decoration bottom-right */}
      <img src="https://cdn.magicpatterns.com/uploads/aRzhnATJxjnpJmo17BGEmX/5.svg" alt="" className="absolute bottom-0 right-0 w-[400px] h-auto pointer-events-none" data-id="element-196" />

      <div ref={ref} className="container mx-auto px-6 md:px-12 text-start relative z-10" data-id="element-197">
        <h2 className={`text-2xl md:text-4xl font-medium text-[#061d76] !leading-[1.5] mb-10 reveal-hidden ${isVisible ? 'animate-fade-up' : ''}`} data-id="element-198">
          {t('partners.description')}
        </h2>
        <button className={`btn-primary reveal-hidden ${isVisible ? 'animate-fade-up delay-300' : ''}`} data-id="element-199">
          {t('partners.learnMore')}
          <ArrowIcon className="w-4 h-4" data-id="element-200" />
        </button>
      </div>
    </section>;
}